import { customFieldActionTypes } from './../constants/ApiConstants';
const initialState = {
  master_data: [],
  loading: false,
  customFieldsList: null,
  customFieldDetails: null,
  saved_customField: null,
  deleted_customField: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case customFieldActionTypes.get_masterdata.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case customFieldActionTypes.get_masterdata.SUCCESS:
    return {
      ...state,
      loading: false,
      master_data: payload,
    };
  case customFieldActionTypes.get_customFieldsList.REQUEST:
    return {
      ...state,
      loading: true,
      customFieldsList: null,
    };
  case customFieldActionTypes.get_customFieldsList.SUCCESS:
    return {
      ...state,
      loading: false,
      customFieldsList: payload,
    };
  case customFieldActionTypes.post_customField.REQUEST:
    return {
      ...state,
      loading: true,
      saved_customField: null,
    };
  case customFieldActionTypes.post_customField.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_customField: payload,
    };
  case customFieldActionTypes.get_customFieldDetails.REQUEST:
    return {
      ...state,
      loading: true,
      customFieldDetails: null,
    };
  case customFieldActionTypes.get_customFieldDetails.SUCCESS:
    return {
      ...state,
      loading: false,
      customFieldDetails: payload,
    };
  case customFieldActionTypes.delete_customField.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_customField: null,
    };
  case customFieldActionTypes.delete_customField.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_customField: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/customFields/reducers/CustomFieldReducer.js